import React, {Component} from 'react'
import { auth, googleProvider, facebookProvider } from '../../firebase.js';
import style from '../../style/style';
import Close from '../../static/img/close.svg';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.authWithGoogle = this.authWithGoogle.bind(this);
    this.authWithFacebook = this.authWithFacebook.bind(this)
    this.authWithEmailPassword = this.authWithEmailPassword.bind(this)
  }

  authWithGoogle = () => {
    auth.signInWithPopup(googleProvider)
      .then((result) => {
        const user = result.user;
        this.setState({
          user
        });
    });
  }

  authWithFacebook = () => {
    console.log("We're authing with Facebook")
  }

  authWithEmailPassword = (event, context) => {
    event.preventDefault()

    const email = this.emailInput.value;
    const password = this.passwordInput.value;
    const refresh = this.props.refresh;
    const close = this.props.handleClose;
    auth.fetchProvidersForEmail(email)
      .then((providers) => {
        console.log("we're hitting the first then")
        if (providers.length === 0) {
          // create user
          return auth.createUserWithEmailAndPassword(email, password)
          .then(function(user){
            if(user && user.emailVerified === false){
              user.sendEmailVerification().then(function(){
                refresh && (document.location.href="/");
                console.log("email verification sent to user");
              });
            }
          }).catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            console.log(errorCode, errorMessage);
          });
        } else if (providers.indexOf("password") === -1) {
          console.log({ message: "Try alternative login.", providers })
        } else {
          // sign in with email/password
          return auth.signInWithEmailAndPassword(email, password)
          .then(function(user){
            close;
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  render() {
    return (
        <div
          style={{
            minHeight: "100vh",
            width: "100vw",
            position: "absolute",
            top: 0,
            left: 0,
            background: "#fcfeff",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "3rem",
            zIndex: 100,
            color: "#000"
          }}
        >
          <div style={{
            maxWidth: "500px",
            padding: "2rem",
            flex: "1"
          }}>

          <button
            style={{
              textDecoration: "none",
              background: style.colors.secondary,
              color: style.colors.primary,
              borderRadius: "50%",
              width: "48px",
              height: "48px",
              alignItems: "center",
              display: "flex",
              border: "none",
              justifyContent: "center",
              marginLeft: "auto"
            }}
            onClick={
              this.props.handleClose
            }
          >
            <img src={Close}
              style={{
                fill: style.colors.primary,
                height: "16px",
                width: "16px"
              }}
            />
          </button>
            
          <div>
            <h2>Log in or create an account</h2>
            <p>Sign up for Dwellist and be the first to find out when we add new features and data.</p>
          </div>

          <form onSubmit={(event) => this.authWithEmailPassword(event)}
            style={{
              display: "flex",
              flexDirection: "column",
              flex: "1",
              marginTop: "2rem",
              marginBottom: "2rem"
            }}
          >
              <label style={style.form.label}>
                Email
              </label>
              <input 
                style={style.form.input}
                name="email" 
                type="email" 
                ref={(input) => {this.emailInput = input}} 
                placeholder="Email">
              </input>
              <label style={style.form.label}>
                Password
              </label>
              <input 
                style={style.form.input}
                name="password" 
                type="password" 
                ref={(input) => {this.passwordInput = input}} 
                placeholder="Password">
              </input>
            <button 
              style={{
                background: style.colors.primary,
                padding: "1rem 0.5rem",
                borderRadius: "4px",
                border: "none",
                color: style.colors.inverse,
                fontFamily: "Poppins, sans-serif",
                fontWeight: 500,
                fontSize: "16px"
              }}
            type="submit">Sign up</button>
            
            <span style={{ fontSize: "12px", marginTop: "1rem"}}>By signing up you agree to recieve emails from Dwellist.</span>

          </form>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/index.js